import { jsx as i } from "react/jsx-runtime";
import { c as k } from "../../index-LULxUVKG.js";
import { Children as L, cloneElement as N } from "react";
import { callAll as j } from "../../utils/utils.js";
import { s as c } from "../../Tabs.module-5GGKgLcA.js";
const t = ({
  children: e,
  className: u,
  fullWidth: s,
  setActiveTab: l,
  activeTab: o,
  onKeyDown: x,
  tabRefs: m,
  tabIds: n,
  inline: C,
  ...f
}) => /* @__PURE__ */ i(
  "ul",
  {
    className: k(
      c.tabList,
      { [c.fullWidth]: s },
      u
    ),
    role: "tablist",
    ...f,
    children: L.map(
      e,
      (p, r) => p ? N(p, {
        fullWidth: s,
        id: n == null ? void 0 : n[r],
        onKeyDown: x,
        ref: m == null ? void 0 : m[r],
        onClick: j(
          () => l == null ? void 0 : l(r),
          p.props.onClick
        ),
        "aria-selected": o === r,
        tabIndex: o === r ? 0 : -1,
        active: o === r,
        inline: C
      }) : null
    )
  }
);
export {
  t as TabList
};
